/* ============
 * Getters for the metatag module
 * ============
 *
 * The getters that are available on the
 * metatag module.
 */

export default {};
